export default __webpack_public_path__ + "assets/small-pin.c09f973a.svg";